









































































































import {Vue, Component, Prop} from 'vue-property-decorator'
import OrbitCurrentRoundContent from '@/components/orbit/OrbitCurrentRoundContent.vue'
import OrbitPreviousRoundContent from '@/components/orbit/OrbitPreviousRoundContent.vue'
import OrbitLeaderboardContent from '@/components/orbit/OrbitLeaderboardContent.vue'
import {OrbitTransactionCollection} from '@/model/collection/OrbitTransactionCollection'
import moment from 'moment'
import {$} from '@/facade'

@Component({
  components: {
    OrbitLeaderboardContent,
    OrbitPreviousRoundContent,
    OrbitCurrentRoundContent,
  },
})
export default class OrbitTableSection extends Vue {
  @Prop({type: Number, required: true}) activeRound!: number
  @Prop({type: Number, required: true}) lastRound!: number
  @Prop({type: String, required: true}) optionSelected!: string

  lastTimeUpdated = ''

  mounted() {
    if (!this.activeRound) {
      this.optionSelected = 'previousRound'
    }

    this.populateResources()
  }

  async populateResources() {
    this.$await.run('populateResources', async () => {
      await this.populateLastTimeUpdated()
    })
  }

  async populateLastTimeUpdated() {
    const lastTransactionCollection = new OrbitTransactionCollection()

    lastTransactionCollection.orderBy = 'updatedAt'
    lastTransactionCollection.asc = false
    lastTransactionCollection.limit = 1

    await lastTransactionCollection.queryAsPage()

    if (
      lastTransactionCollection.items.length > 0 &&
      lastTransactionCollection.items[0].updatedAt
    ) {
      const updatedAt = lastTransactionCollection.items[0].updatedAt
      const date = moment.utc(updatedAt)

      this.lastTimeUpdated = date.format(
        $.translate('dateFormat.datetimeAlmostFull') as string
      )
      return
    }

    this.lastTimeUpdated = 'N/A'
  }

  handleOptionSelected(
    option: 'currentRound' | 'previousRound' | 'leaderboard'
  ) {
    this.$emit('option-selected', option)
  }
}
